import { Notice } from '@buffer-mono/popcorn'

export const CommentDeletedError = (): JSX.Element => {
  return (
    <Notice variant="error" data-testid="comment-deleted-error">
      <Notice.Text>
        <strong>Comment unavailable.</strong> This comment has been deleted or
        is not available.
      </Notice.Text>
    </Notice>
  )
}
